
import { fetchLogin } from "../../features/login/login-service";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import storage from "../../shared/services/storage";
import ButtonPrimary from "../../components/buttons/primary/primary";
import './style.css';
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Loader from "../../components/loader/loader";
import LogoCompleto from '../../assets/logo.png';
import Input from "../../components/inputs/common/input";
import { SEVERITY } from "../../shared/interfaces/alert";
import { useAlert } from "../../components/alert/alert";

export default function Login() {
    const { showAlert } = useAlert();
    const { control, handleSubmit } = useForm({
        defaultValues: {
            email: "",
            password: ""
        }
    });
    
    const [ isLoading, setIsLoading ] = useState(false);
    const navigate = useNavigate();
    
    useEffect(() => {
        if(storage.getStorage('token')) { navigate('/dashboard'); }
    }, [navigate]);
    
    const onLogin: SubmitHandler<any> = async (data) => {
        const { email, password } = data;
        
        setIsLoading(true);
        
        try {
          const res = await fetchLogin({ email, password });

          console.log(res);
          if(res.token) {
            storage.setStorage('token', res.token);
            storage.setStorage('user', JSON.stringify(res.user));

            setIsLoading(false);

            if(res.user.firstAcess) {
                navigate('/primeiro-acesso');
            } else {
                navigate('/dashboard');
            }
          }
        } catch (error) {    
            showAlert('Login e/ou senha inválidos', SEVERITY.ERROR);
        } finally {
            setIsLoading(false);
        }
      };
    
    return (
        <div className="container">
            {isLoading && 
                <div className="container_loader">
                    <Loader/>
                </div>
            }
            <div className="container_upper">
                <img src={LogoCompleto} alt="Logo causale" className="container_upper__logo" />
            </div>
            
            <form className="container__form" onSubmit={handleSubmit(onLogin)}>
                <Controller
                    name="email"
                    control={control}
                    defaultValue=""
                    rules={{ required: "O e-mail é obrigatório" }}
                    render={({ field, fieldState }) => (
                        <Input 
                            {...field}
                            placeholder="E-mail"
                            error={fieldState.error?.message}
                        />
                    )}
                />
                
                <Controller
                    name="password"
                    control={control}
                    defaultValue=""
                    rules={{ required: "A senha é obrigatória" }}
                    render={({ field, fieldState }) => (
                        <Input 
                            {...field}
                            placeholder="Senha"
                            type="password"
                            error={fieldState.error?.message}
                        />
                    )}
                    />

                <ButtonPrimary title="Entrar" type="submit" />
            </form>

            <div className="container_lower">
                <Link className="container_lower__link" to="/recuperar-senha">Esqueceu a senha?</Link>
            </div>
        </div>
    );
}
